//------------------------------------------------------------------------------
// マスター情報 アクション
//------------------------------------------------------------------------------
import types from './types';

/**
 * 汎用マスタ更新
 */
export const setGenericMap = (genericMap) => ({
  type: types.GENERIC,
  genericMap,
});

/**
 * 地区マスタ更新
 */
export const setAreaList = (areaList) => ({
  type: types.AREAS,
  areaList,
});

/**
 * 事業場マスタ更新 (配電) TODO 削除
 */
export const setZigHaiden = (zigHaiden) => ({
  type: types.ZIG_HAIDEN,
  zigHaiden,
});

/**
 * 事業場マスタ更新 (通信) TODO 削除
 */
export const setZigTushin = (zigTushin) => ({
  type: types.ZIG_TUSHIN,
  zigTushin,
});

/**
 * マスタ取得状態
 */
export const setLoaded = (loaded) => ({
  type: types.LOADED,
  loaded,
});

// デフォルトエクスポート
export default {
  setGenericMap,
  setAreaList,
  setZigHaiden,
  setZigTushin,
  setLoaded,
};
